import {Component, OnInit} from '@angular/core';
import {HalDocumentService} from 'hateoas-navigator';
import {NavigationItem} from 'hateoas-navigator';
import {flatMap} from 'rxjs/operators';

@Component({
  selector: 'app-navigation',
  template: `<mat-toolbar color="primary" class="mat-elevation-z6 cmp-toolbar">
  <span>
    <a mat-button routerLink="/">
      <mat-icon>home</mat-icon>
      <span>HATEOAS Navigator</span>
    </a>
  </span>
  <span *ngFor="let item of items">
    <a mat-button routerLink="/{{item.link}}">{{item.title}}</a>
  </span>
</mat-toolbar>
`,
  styles: [`.cmp-toolbar{position:-webkit-sticky;position:sticky;top:0;z-index:50}`]
})
export class NavigationComponent implements OnInit {
  items: Array<NavigationItem>;

  constructor(private halDocumentService: HalDocumentService) {

  }

  ngOnInit(): void {
    this.halDocumentService.getRootNavigation()
      .pipe(flatMap(navigation => navigation.getItems()))
      .subscribe(items => this.items = items);
  }
}
